import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import TreasuryChart from "../Treasury/TreasuryChart";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
class TreasuryContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"TREASURY"}
        // header={"ids_treasury"}
        header={"ids_reports"}
        query={Queries.getTreasuryReportData}
        Chart={TreasuryChart}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(TreasuryContainer));
